module.exports = __webpack_public_path__ + "img/chinesecompany95.448e6e81.png";